"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositState = void 0;
/**
 * Represents the state of the deposit.
 */
var DepositState;
(function (DepositState) {
    // eslint-disable-next-line no-unused-vars
    DepositState[DepositState["UNKNOWN"] = 0] = "UNKNOWN";
    // eslint-disable-next-line no-unused-vars
    DepositState[DepositState["INITIALIZED"] = 1] = "INITIALIZED";
    // eslint-disable-next-line no-unused-vars
    DepositState[DepositState["FINALIZED"] = 2] = "FINALIZED";
})(DepositState = exports.DepositState || (exports.DepositState = {}));
//# sourceMappingURL=cross-chain.js.map